import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import { Button, Card, Table } from "react-bootstrap";

function PoolPage() {
    return (<>
        <Navbar />
        <Card>
            <Card.Header>Schwimmhallentraining</Card.Header>
            <Card.Body>
                <Card.Text>
                    Als Mitglied unseres Vereins hast du die Möglichkeit, regelmäßig beim Schwimmhallentraining deine Fähigkeiten und Kondition zu verbessern.
                    Du triffst Freunde, kannst Erfahrungen austauschen und beispielsweise gleich das nächste Tauchziel besprechen.
                    <br /><br />
                    Unsere Übungsleiter und Tauchlehrer leiten das Kinder- und Jugendtraining. Die Erwachsenen trainieren in Eigenregie oder in unserer Trainingsgruppe für fortgeschrittenes Flossenschwimmen und Apnoe.
                    <br /><br />
                    Das Training findet dienstags im <a href="https://www.stadtbad-hennigsdorf.de/" target="_blank" rel="noopener noreferrer">Stadtbad Hennigsdorf</a> statt.
                </Card.Text>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Uhrzeit</th>
                            <th>Training</th>
                            <th>Bahnen</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>18:00 Uhr - 19:00 Uhr</td>
                            <td>Kinder- und Jugendtraining</td>
                            <td>2 Bahnen</td>
                        </tr>
                        <tr>
                            <td>18:00 Uhr - 19:00 Uhr</td>
                            <td>Erwachsene (Eltern)</td>
                            <td>1 Bahn</td>
                        </tr>
                        <tr>
                            <td>18:00 Uhr - 19:00 Uhr</td>
                            <td>Fortgeschrittenes Training – Apnoe</td>
                            <td>1 Bahn</td>
                        </tr>
                        <tr>
                            <td>19:00 Uhr - 20:00 Uhr</td>
                            <td>Freies Erwachsenentraining</td>
                            <td>3 Bahnen</td>
                        </tr>
                    </tbody>
                </Table>
                <Card.Text>
                    An Feiertagen und während der Schulferien des Landes Brandenburg findet kein Training statt.
                </Card.Text>
            </Card.Body>
        </Card>

        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>);
}

export default PoolPage;
